"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeSettings = BadgeSettings;
var jsx_runtime_1 = require("react/jsx-runtime");
var item_details_1 = require("../../components/item_details");
var item_settings_1 = require("../../components/item_settings");
var item_usage_1 = require("../../components/item_usage");
var badge_appearance_1 = require("./badge_appearance");
var badge_preview_1 = require("./badge_preview");
var validateBadge = function (draft) {
    var _a, _b, _c;
    var theme = (_a = draft.badge) === null || _a === void 0 ? void 0 : _a.theme;
    return {
        badge: {
            sub_copy: ((_c = (_b = draft.badge) === null || _b === void 0 ? void 0 : _b.sub_copy) === null || _c === void 0 ? void 0 : _c.trim()) ? "" : "Sub copy is required",
            theme: {
                primary: (theme === null || theme === void 0 ? void 0 : theme.primary) ? "" : "Primary theme color is required",
                name: (theme === null || theme === void 0 ? void 0 : theme.name) ? "" : "Name theme color is required",
                sub_copy: (theme === null || theme === void 0 ? void 0 : theme.sub_copy) ? "" : "Sub copy theme color is required",
                background: (theme === null || theme === void 0 ? void 0 : theme.background) ? "" : "Background theme color is required",
                icon: (theme === null || theme === void 0 ? void 0 : theme.icon) ? "" : "Icon theme color is required",
            },
        },
    };
};
function BadgeSettings(_a) {
    var item = _a.item, actions_container = _a.actions_container;
    return ((0, jsx_runtime_1.jsx)(item_settings_1.ItemSettings, { item: item, item_type: "badge", actions_container: actions_container, validate_type: validateBadge, preview: (0, jsx_runtime_1.jsx)(badge_preview_1.BadgePreview, {}), render_sections: function (is_read_only) { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(item_details_1.ItemDetails, { is_read_only: is_read_only }), (0, jsx_runtime_1.jsx)(item_usage_1.ItemUsage, { is_read_only: is_read_only }), (0, jsx_runtime_1.jsx)(badge_appearance_1.BadgeAppearance, { is_read_only: is_read_only })] })); } }));
}
